import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputHtmlTextSF from '../../../widgets/form/InputHtmlTextSF';

const CovenantComplianceUpdateModalUI = ({
    context, successMsg, errorList, setErrorList, submitted,
    updateMode, onSubmit, onCancelClick,
    nonComplianceText, onNonComplianceTextChange, onNonComplianceTextError, setNonComplianceTextError,
    remedialActionText, onRemedialActionTextChange, remedialActionTextError, setRemedialActionTextError
}) => {
    return (
        <ModalFormUI
            context={context}
            titleLabel='Update message'
            buttonLabel="Update"
            cancelLabel="Cancel"
            isOpen={updateMode}
            onRequestClose={onCancelClick}
            successMsg={successMsg}
            errorList={errorList}
            setErrorList={setErrorList}
            onSubmit={onSubmit}
            busy={submitted}
        >
            <InputHtmlTextSF type="text" label="Non Compliance Text" required={true} height={200}
                value={nonComplianceText} onChange={onNonComplianceTextChange}
                error={onNonComplianceTextError} setError={setNonComplianceTextError}
            />
            <InputHtmlTextSF type="text" label="Remedial Action" required={true} height={200}
                value={remedialActionText} onChange={onRemedialActionTextChange}
                error={remedialActionTextError} setError={setRemedialActionTextError}
            />
        </ModalFormUI>
    );
};

export default CovenantComplianceUpdateModalUI;
